import { render, staticRenderFns } from "./NomineeDetailsCorrection.vue?vue&type=template&id=5864ec33"
import script from "./NomineeDetailsCorrection.vue?vue&type=script&lang=js"
export * from "./NomineeDetailsCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports